import { createSelector } from 'reselect';
import { v4 as uuidv4 } from 'uuid';

import { MediaStatusEnum } from 'modules/global/typing/enums/media.enum';
import { getProps } from 'utils/selectors';

import { DEFAULT_LOADING_MEDIA } from '../../components/common/UploadModal/utils';

/** @return {import("./reducer").MediasReducer} */
const getState = state => state.medias;

const getActions = createSelector(getState, state => state.actions);

const getData = createSelector(getState, state => state.data);

const getUI = createSelector(getState, state => state.ui);

const getDefrostingMedias = createSelector(getState, state => state.defrostingMedias);

const getId = (_, id) => id;

const getSource = (_, source) => source;

const getUploads = createSelector(getActions, actions => actions.uploads);

const getEntry = createSelector(getUploads, getSource, (medias, source) => medias?.[source]);

export const getMedias = createSelector(getEntry, entry => entry?.medias ?? []);

export const isLoading = createSelector(getEntry, entry => entry?.isLoading);

const getRemainingMediaToUpload = createSelector(getEntry, entry => entry?.remainingMediaToUpload);

export const getLoadingMedias = createSelector(
  getRemainingMediaToUpload,
  (remainingMediaCount = 0) => [...Array(remainingMediaCount).keys()].map(() => ({
    ...DEFAULT_LOADING_MEDIA,
    uuid: uuidv4(),
  }))
);

export const getMediaByIds = createSelector(
  getData,
  getId,
  ({ entities: medias }, ids) => ids.reduce((acc, id) => {
    if (medias[id]) {
      acc.push(medias[id]);
    }
    return acc;
  }, [])
);

export const getMediaIdsToDelete = createSelector(getUI, ({ idsToDelete }) => idsToDelete);

export const isPatching = createSelector(getUI, ui => ui.isPatching);

export const isDeleting = createSelector(getUI, ui => ui.isDeleting);

export const isUploading = createSelector(getUI, ui => ui.isUploading);

export const isPersisting = createSelector(getUI, ui => ui.isPersisting);

// section concerning the defrost
export const getHasDefrostingMedias = createSelector(getDefrostingMedias, ({ data }) => data.ids.length > 0);
export const getDefrostingIsLoading = createSelector(getDefrostingMedias, ({ loading }) => loading);

export const getMediaIsDefrostingById = createSelector(
  getDefrostingMedias,
  getProps,
  ({ data }, media) => {
    const { id } = media;
    const status = data.entities[id]?.status ?? media.status;
    return status === MediaStatusEnum.RESTORING;
  }
);
